/* ============================================================
   hiba-player.js — The Reprogramming audio players
   Wires every .hr-track in a room: play/pause, scrub, time,
   download (unlocked only), Media Session (lock-screen play).

   Gate is server-rendered: .hr-room.is-unlocked => full play +
   download on all tracks. When LOCKED (Zoobs v2 model):
     - only the first (release) track previews — a curated 30s
       window starting at data-preview-start (the emotional peak,
       not the intro);
     - tracks marked data-locked-track are disabled until bought.
   Drives the living background via window.HibaLivingBG.
   ============================================================ */
(function () {
  'use strict';

  var PREVIEW_SECONDS = 30;

  function fmt(s) {
    if (isNaN(s) || !isFinite(s)) return '0:00';
    var m = Math.floor(s / 60), x = Math.floor(s % 60);
    return m + ':' + (x < 10 ? '0' : '') + x;
  }

  function boot() {
    var room = document.querySelector('.hr-room');
    if (!room) return;
    var unlocked = room.classList.contains('is-unlocked');
    var tracks = Array.prototype.slice.call(room.querySelectorAll('.hr-track'));
    if (!tracks.length) return;

    var artwork = room.getAttribute('data-artwork') || '';
    var audios = [];
    var AC = null, analyser = null;

    function ensureAudioCtx() {
      if (AC) return;
      try {
        AC = new (window.AudioContext || window.webkitAudioContext)();
        analyser = AC.createAnalyser();
        analyser.fftSize = 128;
        analyser.connect(AC.destination);
        if (window.HibaLivingBG) window.HibaLivingBG.attachAnalyser(analyser);
      } catch (e) { AC = null; }
    }

    function stopOthers(except) {
      audios.forEach(function (a) { if (a !== except) a.pause(); });
      tracks.forEach(function (t) { t.classList.remove('is-playing'); });
    }

    function setMediaSession(title, audio) {
      if (!('mediaSession' in navigator)) return;
      try {
        var art = artwork ? [{ src: artwork, sizes: '512x512', type: 'image/jpeg' }] : [];
        navigator.mediaSession.metadata = new window.MediaMetadata({
          title: title, artist: 'Hiba Balfaqih', album: 'The Reprogramming', artwork: art
        });
        navigator.mediaSession.setActionHandler('play', function () { audio.play(); });
        navigator.mediaSession.setActionHandler('pause', function () { audio.pause(); });
        navigator.mediaSession.setActionHandler('seekbackward', function () {
          audio.currentTime = Math.max(0, audio.currentTime - 10);
        });
        navigator.mediaSession.setActionHandler('seekforward', function () {
          audio.currentTime = Math.min(audio.duration || Infinity, audio.currentTime + 10);
        });
      } catch (e) { /* unsupported action — ignore */ }
    }

    tracks.forEach(function (el, idx) {
      var src = el.getAttribute('data-src');
      var title = el.getAttribute('data-title') || 'Track';
      if (!src) return;

      var previewStart = parseFloat(el.getAttribute('data-preview-start')) || 0;
      var previewEnd = parseFloat(el.getAttribute('data-preview-end')) || 0;
      // Curated clip length — sentence-clean window; falls back to fixed 30s.
      var previewLen = (previewEnd > previewStart) ? (previewEnd - previewStart) : PREVIEW_SECONDS;
      var isLockedTrack = el.hasAttribute('data-locked-track');   // tracks 2 & 3
      // When locked, only the release track previews (within its window).
      var previewing = !unlocked && !isLockedTrack;

      var btn = el.querySelector('.hr-play');
      var bar = el.querySelector('.hr-bar');
      var fill = el.querySelector('.hr-bar__fill');
      var time = el.querySelector('.hr-time');

      var audio = new Audio();
      audio.preload = 'none';
      audio.src = src;
      audios.push(audio);

      btn.addEventListener('click', function () {
        if (!unlocked && isLockedTrack) return;   // locked tracks: no-op until bought
        stopOthers(audio);
        if (audio.paused) {
          ensureAudioCtx();
          if (AC) {
            AC.resume();
            if (!audio._wired) {
              try { AC.createMediaElementSource(audio).connect(analyser); }
              catch (e) { /* already wired or unsupported */ }
              audio._wired = true;
            }
          }
          if (previewing) audio.currentTime = previewStart;   // start the curated window
          audio.play();
          btn.textContent = '❚❚';
          el.classList.add('is-playing');
          if (window.HibaLivingBG) window.HibaLivingBG.setPlayIndex(idx);
          setMediaSession(title, audio);
        } else {
          audio.pause();
          btn.textContent = '▶';
          if (window.HibaLivingBG) window.HibaLivingBG.setPlayIndex(-1);
        }
      });

      audio.addEventListener('timeupdate', function () {
        if (previewing) {
          // Hard-stop at the end of the curated preview window; reset to its start.
          if (audio.currentTime >= previewStart + previewLen) {
            audio.pause();
            audio.currentTime = previewStart;
            btn.textContent = '▶';
            el.classList.remove('is-playing');
            if (window.HibaLivingBG) window.HibaLivingBG.setPlayIndex(-1);
            return;
          }
          var elapsed = Math.max(0, audio.currentTime - previewStart);
          fill.style.right = (100 - (elapsed / previewLen) * 100) + '%';
          time.textContent = fmt(elapsed) + ' / ' + fmt(previewLen);
        } else {
          var dur = audio.duration || 1;
          fill.style.right = (100 - (audio.currentTime / dur) * 100) + '%';
          time.textContent = fmt(audio.currentTime) + ' / ' + fmt(audio.duration);
        }
      });

      audio.addEventListener('ended', function () {
        btn.textContent = '▶';
        el.classList.remove('is-playing');
        fill.style.right = '100%';
        if (window.HibaLivingBG) window.HibaLivingBG.setPlayIndex(-1);
      });

      // Scrub within the allowed range (preview window when previewing, full when unlocked).
      if (bar) {
        bar.addEventListener('click', function (ev) {
          if (!unlocked && isLockedTrack) return;
          var rect = bar.getBoundingClientRect();
          var ratio = Math.min(1, Math.max(0, (ev.clientX - rect.left) / rect.width));
          if (previewing) {
            audio.currentTime = previewStart + ratio * previewLen;
          } else if (audio.duration) {
            audio.currentTime = ratio * audio.duration;
          }
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
